/**
 * gridView
 * @Object {Object} axboot.gridView
 */
axboot.gridView = {
    name: 'grid',
    page: {
        //pageNumber : 0,
        pageSize   : axboot.def.defaultPageSize
    },
    setValue: function (_dindex, _key, _value) {
        this.target.setValue(_dindex, _key, _value);

        axboot.util.bindingTarget(this.target.$target, this.getSelectedData());
    },
    setData: function setData(_data) {
        this.target.setData(_data);
    },
    getData: function getData(_type) {
        var list = [];
        var _list = this.target.getList(_type);
        if (_type == 'modified' || _type == 'deleted') {
            list = ax5.util.filter(_list, function () {
                return true;
            });
        } else {
            list = _list;
        }
        return list;
    },
    getSelectedData : function () {
        return this.getData()[this.getSelectedIndex()];
    },
    getSelectedValue: function (_key) {
        return this.getSelectedData()[_key];
    },
    setSelectedValue: function (_key, _value) {
        var selectedIndex = this.getSelectedIndex();

        if (!ax5.util.isNothing(selectedIndex)) {
            this.setValue(selectedIndex, _key, _value);
        }
    },
    getSelectedIndex : function () {
        return this.target.selectedDataIndexs[this.target.selectedDataIndexs.length - 1];
    },
    getSelectedIndexs : function () {
        return this.target.selectedDataIndexs;
    },
    isSelected : function () {
        return (this.target.selectedDataIndexs.length > 0);
    },
    addRow: function addRow(_data, _dindex, _options) {
        var selectedIndex = -1;
        var defaultData = $.extend({}, _data, { __created__: true });

        /* 2019.12.06 (이상훈) : 0 번 행으로 입력행 추가시 입력행으로 인식하지 못하는 오류로 인한 처리 */
        if (_dindex === 0) {
            defaultData['__modified__'] = true;
        }

        if (ax5.util.isString(_dindex) || ax5.util.isNumber(_dindex)) {
            selectedIndex = _dindex;

            this.target.addRow(defaultData, _dindex, _options);
            this.target.select(_dindex, { selectedClear : true, selected : true });
        } else {
            selectedIndex = this.target.list.length;

            this.target.addRow(defaultData, 'last', { focus: 'END' });
            this.target.select(selectedIndex, { selectedClear : true, selected : true });
        }

        axboot.util.bindingTarget(this.target.$target, this.getSelectedData());
    },
    updateRow: function updateRow(_data, _dindex) {
        var selectedIndex = -1;
        var defaultData = $.extend({}, _data, { __modified__: true });

        this.target.updateRow(_data, _dindex);
    },
    delRow: function delRow(_type) {
        this.target.deleteRow(_type);
    },
    align: function align() {
        this.target.align();
    },
    clear: function clear() {
        this.target.setData({
            list: [],
            page: {
                currentPage: 0,
                pageSize: 0,
                totalElements: 0,
                totalPages: 0
            }
        });
    },
    setPageData: function setPageData(_page) {
        this.page = $.extend(this.page, _page);
    },
    getPageData: function getPageData() {
        var sortInfos =  this.target.sortInfo;

        var sortParams = new Array();
        var sortParamMap = {};
        var sortParam = {};

        for (var key in sortInfos) {
            sortParamMap = {};
            sortParamMap['columnNm'] = key;

            for (var subKey in sortInfos[key]) {
                if (subKey == 'seq') {
                    sortParamMap['columnSeq'] = sortInfos[key][subKey];
                } else if (subKey == 'orderBy') {
                    sortParamMap['orderBy'] = sortInfos[key][subKey];
                }
            }

            sortParams.push(sortParamMap);
        }

        /*
        sortParams.sort(function(a, b) {
            return b['columnSeq'] - a['columnSeq'];
        });
        */

        sortParam['sortInfo'] = sortParams.reverse();

        return $.extend({}, this.page, sortParam);
    },
    setPageNo: function (pageNo) {
        this.setPageData({ 'currentPage' : pageNo });
    },
    select: function (rowIndex, options) {
        if (ax5.util.isNothing(options)) {
            options = { selectedClear : true };
        }

        this.target.select(rowIndex, options);
    },
    selectAll: function (selected) {
        if (selected === undefined) {
            selected = true;
        }

        this.target.selectAll({selected: selected});
    }
};
